import {
  INIT_RENDER_DELAY,
  INIT_RENDER_INC,
  INIT_RENDER_TOTAL,
  RENDER_DELAY,
  RENDER_INC,
} from '@/constants'

export function generatePartId(part: any): string {
  return (part.cpn + '-' + part.mpn).toLowerCase().replace(/\s/g, '')
}

export function generateSalesOrderId(item: any): string {
  return (item.salesOrderNumber + '-' + item.salesOrderLineItemNumber)
    .toLowerCase()
    .replace(/\s/g, '')
}

export function sortData(data: any[], column: string, order: 'asc' | 'desc') {
  return data.slice(0).sort((a: any, b: any) => {
    let modifier = 1
    if (order === 'desc') modifier = -1
    if (a[column] === b[column]) return 0
    if (!a[column]) return -1 * modifier
    if (!b[column]) return 1 * modifier
    if (a[column] < b[column]) return -1 * modifier
    if (a[column] > b[column]) return 1 * modifier
    return 0
  })
}

export function fileDownload(
  data: string | ArrayBuffer | ArrayBufferView | Blob,
  filename: string,
  mime?: string,
  bom?: any,
) {
  const blobData = typeof bom !== 'undefined' ? [bom, data] : [data]
  const blob = new Blob(blobData, { type: mime || 'application/octet-stream' })
  const tempFilename = filename
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // IE workaround for "HTML7007: One or more blob URLs were
    // revoked by closing the blob for which they were created.
    // These URLs will no longer resolve as the data backing
    // the URL has been freed."
    window.navigator.msSaveBlob(blob, filename)
  } else {
    const reader = new FileReader()
    reader.onloadend = () => {
      const a: any = document.createElement('a')
      a.href = reader.result
      a.style.display = 'none'
      a.download = tempFilename
      document.body.appendChild(a)
      a.click()
      a.parentNode.removeChild(a)
    }
    reader.readAsDataURL(blob)
  }
}

export function getRenderIncrement(numRendered: number) {
  const delay = numRendered > INIT_RENDER_TOTAL ? RENDER_DELAY : INIT_RENDER_DELAY
  const increment = numRendered > INIT_RENDER_TOTAL ? RENDER_INC : INIT_RENDER_INC
  return { delay, increment }
}

interface FormattedError {
  status: string
  url: string
  details: string
}

export function formatApiError(error: any): FormattedError {
  // String Types
  // status, url, details

  const status = error.response.status + ' ' + error.response.statusText
  const url = error.response.config.url

  // Potential types of errors
  // 1.Friendly: 400 range - response: "error msg"
  // 2.NET: 400 range - response: {"errors":{"action":["error msg"]},"title":"One or more validation errors occurred.","status":400,"traceId":"0HLPCKB0FV189:00000008"}
  // 3.SAP: 500 - response: { "error": "error msg" }
  let details = ''
  if (error.response.status == '500') {
    details += error.response.data.error
  } else {
    if (typeof error.response.data.errors === 'object') {
      // the error response object is in the form of { keyA: [err1, err2], keyB: [err3] }
      const errors = (Object.values(error.response.data.errors).reduce((acc, val) => ({
        ...acc,
        ...val,
      })) as string[])
        .map(msg => `<br />&bull; ${msg}`)
        .join('')
        .concat('<br />')
      details += error.response.data.title
      details += errors
    } else {
      details += error.response.data
    }
  }
  return { status, url, details }
}
